import { connect } from 'react-redux';
import { graphql, compose } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import ViewMember from '../../components/ViewMember';
import orderNewCard from '../../mutations/orderNewCard';
import { setSuccessMessage, setErrorMessage, setInfoMessage } from '../../actions/messages';
import { setMemberRequest, removeMemberRequest } from '../../actions';

export const mapStateToProps = ({ memberRequest }) => ({
  memberRequest,
});

export default compose(
  graphql(orderNewCard, {
    name: 'orderNewCard',
    options: { notifyOnNetworkStatusChange: true },
  }),
)(withRouter(connect(mapStateToProps, {
  setMemberRequest,
  removeMemberRequest,
  setSuccessMessage,
  setErrorMessage,
  setInfoMessage,
})(ViewMember)));



// WEBPACK FOOTER //
// ./src/app/containers/ViewMember/index.js